import LayoutWrapper from "../components/layouts/layoutWrapper";
import { config } from '@fortawesome/fontawesome-svg-core';
config.autoAddCss = false;
import 'nprogress/nprogress.css';
import '@/styles/globals.css';
import '@fortawesome/fontawesome-svg-core/styles.css';
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-datepicker/dist/react-datepicker.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.min.css';
import '@/styles/bs-custom.css';
import "@/styles/dash-styles.scss";
import '@/styles/poll-style.css';
import '@/styles/admin-styles.css';
import '@/styles/public_style.css';
import '@/styles/business.css';
import '@/styles/reseller.css';
import '@/styles/header.css';
import '@/styles/about.css';
import '@/styles/industry.css';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import "react-datepicker/dist/react-datepicker.css";
import "react-phone-number-input/style.css";
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useState } from "react";
import NProgress from 'nprogress';
import Head from "next/head";
import { StoreProvider } from "@/providers/StoreProvider";

const PersistGateWrapper = dynamic(
    () => import('@/providers/PersistGateWrapper'),
    { ssr: false }
);
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'

export default function App({ Component, pageProps }) {
  const [queryClient] = useState(() => new QueryClient());
  const router = useRouter();

  useEffect(() => {
    import("bootstrap/dist/js/bootstrap.bundle.min.js");

    const handleRouteChangeStart = (url) => {
      NProgress.start();
    };
    const handleRouteChangeEnd = () => {
      NProgress.done();
    };

    router.events.on('routeChangeStart', handleRouteChangeStart);
    router.events.on('routeChangeComplete', handleRouteChangeEnd);
    router.events.on('routeChangeError', handleRouteChangeEnd);

    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart);
      router.events.off('routeChangeComplete', handleRouteChangeEnd);
      router.events.off('routeChangeError', handleRouteChangeEnd);
    };
  }, [router.events]);

  const getLayout = Component.getLayout
    ? Component.getLayout
    : (page) => <LayoutWrapper {...pageProps}>{page}</LayoutWrapper>;


  return (
    <>
      <Head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta httpEquiv="Cache-Control" content="no-cache, no-store, must-revalidate" />
      </Head>
      <QueryClientProvider client={queryClient}>
        <StoreProvider>
            <PersistGateWrapper>
                {getLayout(<Component {...pageProps} />)}
            </PersistGateWrapper>
        </StoreProvider>
      </QueryClientProvider>
    </>
  );
};
